export const MessageHeader = () => {
  return (
    <>
      <h3 className="text-xl font-bold mb-4">
        Message pour les Axonais
      </h3>
      <p className="text-gray-600 text-sm mb-4">
        (Et les curieux de la France entière)
      </p>
    </>
  );
};